import type { PropsWithChildren, SVGProps } from 'react';

import { unitMapping } from '#src/lib/style.ts';

type Props = SVGProps<SVGSVGElement> & {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
};

export const SvgIcon = ({
  title,
  titleId,
  size = 2,
  children,
  ...props
}: PropsWithChildren<Props>) => (
  <svg
    fill="none"
    aria-labelledby={titleId}
    style={{ height: unitMapping[size] }}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {children}
  </svg>
);
